import React, { useState, useContext, useEffect } from 'react';
import styles from './ZavrsniRadovi.module.css';
import Breadcrumb from './Breadcrumb';
import ZavrsniRadoviNav from './ZavrsniRadoviNav';
import {
  ZAVRSNI_RADOVI_FETCH_SIZE,
  BASE_URL_ZAVRSNI_RADOVI,
  STATUS_ZAVRSNI_RAD_CUSTOM
} from '../util/constants';
import { ThemeContext } from '../contexts/ThemeContext';
import ZavrsniRad from './ZavrsniRad';
import { toRealZavrsniRadStatus } from '../util/statusZavrsniRadMapper';
import { toRealCiklus } from '../util/ciklusFilterMapper';

const ZavrsniRadovi = () => {
  const [zavrsniRadovi, setZavrsniRadovi] = useState([]);
  const [prikazOffset, setPrikazOffset] = useState(0);
  const [ukupanBrojRadova, setUkupanBrojRadova] = useState(0);
  const [prikazSize, setPrikazSize] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchField, setSearchField] = useState("");
  const [selectedCiklus, setSelectedCiklus] = useState("Svi");
  const [selectedStatus, setSelectedStatus] = useState("Svi");
  const { dark } = useContext(ThemeContext);

  useEffect(() => {
    let fetchParams = {
      "where": [],
      "orderBy": [],
      "fetchSize": ZAVRSNI_RADOVI_FETCH_SIZE,
      "fetchOffset": prikazOffset
    };

    if (selectedStatus !== undefined && selectedStatus !== "Svi") {
      fetchParams['where'][fetchParams['where'].length] = {
        "operator": "like",
        "field": "trenutniStatus.statusZavrsnogRada.naziv",
        "value": toRealZavrsniRadStatus(selectedStatus)
      };
    }

    if (selectedCiklus !== undefined && selectedCiklus !== "Svi") {
      fetchParams['where'][fetchParams['where'].length] = {
        "operator": "equal",
        "field": "ciklus",
        "value": toRealCiklus(selectedCiklus)
      };
    }

    if (searchTerm === undefined || searchTerm === "") {
      fetchApiData(fetchParams);
    }
    else {
      fetchParams['where'][fetchParams['where'].length] = {
        "operator": "ilike",
        "field": searchField,
        "value": searchTerm
      };

      fetchApiData(fetchParams);
    }

  }, [prikazOffset, searchTerm, searchField, selectedCiklus, selectedStatus]);

  const fetchApiData = (filter) => {
    let fetchParamsEncoded = encodeURI(encodeURI(JSON.stringify(filter)));
    fetch(BASE_URL_ZAVRSNI_RADOVI + "?filter=" + fetchParamsEncoded)
      .then(response => response.json())
      .then(radoviList => {
        setZavrsniRadovi(radoviList.content);
        setUkupanBrojRadova(radoviList.total);
        setPrikazSize(radoviList.size);
      })
      .catch(function (err) {
        console.log('Fetch Error :', err);
      });
  }

  const showNextPage = () => {
    setPrikazOffset(prikazOffset + ZAVRSNI_RADOVI_FETCH_SIZE);
  }

  const showPreviousPage = () => {
    setPrikazOffset(prikazOffset - ZAVRSNI_RADOVI_FETCH_SIZE);
  }

  const filterRadovi = (term, field) => {
    if ("trenutniStatus.statusZavrsnogRada.naziv" === field) {
      if ("slobodan" === term.toLowerCase()) {
        term = "Odobren";
      } else if ("zauzet" === term.toLowerCase()) {
        term = "Dodjeljen";
      } else if ("odbranjen" === term.toLowerCase()) {
        term = "Odbranjen";
      }
    }

    setSearchTerm(term);
    setSearchField(field);
    setPrikazOffset(0);
  }

  return (
    <>
      <Breadcrumb path={['Početna', 'Završni radovi']} />
      <div className={styles.zavrsniRadoviContent}>
        <ZavrsniRadoviNav
          prikazSize={prikazSize}
          ukupanBrojRadova={ukupanBrojRadova}
          prikazOffset={prikazOffset}
          showNextPage={showNextPage}
          showPreviousPage={showPreviousPage}
          filterRadovi={filterRadovi}
          setSelectedCiklus={setSelectedCiklus}
          setSelectedStatus={setSelectedStatus}
          selectedCiklus={selectedCiklus}
          selectedStatus={selectedStatus} />
        <div>
          {zavrsniRadovi === undefined || zavrsniRadovi.length === 0 ? (
            <div className={dark ? styles.endOfResultsContainerDark : styles.endOfResultsContainerLight}>
              Nema odgovarajućih rezultata.
            </div>
            //null
          ) : (
              <>
                {zavrsniRadovi.map(rad => {
                  return (
                    <ZavrsniRad
                      tema={rad.tema}
                      obrazlozenje={rad.obrazlozenje}
                      mentor={rad.mentor.ime}
                      predsjednikKomisije={rad.predsjednikKomisije.ime}
                      clanKomisije={rad.clanKomisije.ime}
                      studentIme={rad.studentIme}
                      status={STATUS_ZAVRSNI_RAD_CUSTOM[rad.trenutniStatus.statusZavrsnogRada.id]}
                      radId={rad.id}
                      key={rad.id} />
                  );
                })}
                {prikazOffset + ZAVRSNI_RADOVI_FETCH_SIZE < ukupanBrojRadova ? null : (
                  <div className={dark ? styles.endOfResultsContainerDark : styles.endOfResultsContainerLight}>
                    Kraj rezultata
                  </div>
                )}
              </>
            )}
        </div>
        {/* 
        <div className={styles.paginationBottomContainer}>
          <ZavrsniRadoviPagination
            prikazSize={prikazSize}
            ukupanBrojRadova={ukupanBrojRadova}
            prikazOffset={prikazOffset}
            showNextPage={showNextPage}
            showPreviousPage={showPreviousPage} />
        </div>
        */}
      </div>
    </>
  );
}

export default ZavrsniRadovi;